import classes from "./GearDatabaseList.module.css"
import Select, { createFilter } from "react-select"
import gearHead from "../../assets/json/parameters/GearInfoHead.json"
import gearClothes from "../../assets/json/parameters/GearInfoClothes.json"
import gearShoes from "../../assets/json/parameters/GearInfoShoes.json"
import { useLocalStorage } from "../../Utils"
import { defaultGearList } from "../../DefaultEntries"
import { useTranslation } from "react-i18next"
import { getName, default_single_style } from "../../Utils"

const GearDatabaseList = props => {
    const { t } = useTranslation()

    const [gearList] = useLocalStorage("gearList", defaultGearList)
    const ds = default_single_style()

    const getGearLabel = (gear, type) => {
        const langList =
            type === 0
                ? "CommonMsg.Gear.GearName_Head"
                : type === 1
                ? "CommonMsg.Gear.GearName_Clothes"
                : "CommonMsg.Gear.GearName_Shoes"
        return getName(t, langList, gear)
    }

    const getGearEntries = () => {
        const entries = []

        for (const [key, val] of Object.entries(gearList.HaveGearHeadMap)) {
            if (props.filterFunction(val) && val.Favorite) {
                const pgear = gearHead.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 0),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 0,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }

        for (const [key, val] of Object.entries(gearList.HaveGearClothesMap)) {
            if (props.filterFunction(val) && val.Favorite) {
                const pgear = gearClothes.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 1),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 1,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }
        for (const [key, val] of Object.entries(gearList.HaveGearShoesMap)) {
            if (props.filterFunction(val) && val.Favorite) {
                const pgear = gearShoes.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 2),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 2,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }

        for (const [key, val] of Object.entries(gearList.HaveGearHeadMap)) {
            if (props.filterFunction(val) && !val.Favorite) {
                const pgear = gearHead.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 0),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 0,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }

        for (const [key, val] of Object.entries(gearList.HaveGearClothesMap)) {
            if (props.filterFunction(val) && !val.Favorite) {
                const pgear = gearClothes.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 1),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 1,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }
        for (const [key, val] of Object.entries(gearList.HaveGearShoesMap)) {
            if (props.filterFunction(val) && !val.Favorite) {
                const pgear = gearShoes.filter(elem => elem.Id === parseInt(key))
                if (pgear[0] !== undefined) {
                    const entry = {
                        Id: parseInt(key),
                        label: getGearLabel(pgear[0], 2),
                        ImgName: pgear[0].__RowId,
                        value: pgear[0],
                        Seed: val.RandomContext,
                        OriginalEntry: val,
                        Type: 2,
                    }
                    entries.push(entry)
                } else {
                    console.log(key)
                }
            }
        }
        return entries
    }

    const entries = getGearEntries()

    const filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: "any",
    }

    return (
        <div className={classes.SettingsContent}>
            <p>{t("misc:Checker.HaveGear")}</p>
            <p>
                <strong>{t("translation:LayoutMsg.Cmn_Menu_00.L_Player_00-T_BlackText_00")}:</strong>
            </p>
            <Select
                isSearchable
                filterOption={createFilter(filterConfig)}
                value={props.currentGear}
                onChange={props.gearChange}
                options={entries}
                styles={ds}
                formatOptionLabel={elem => {
                    if (elem.ImgName === undefined) {
                        return t("misc:Common.None")
                    }
                    const url = `https://leanny.github.io/splat3/images/gear/${elem.ImgName}.png`
                    return (
                        <>
                            <img src={url} width="32" alt={elem.label} />
                            <span className={classes.Gap}> {elem.label}</span>
                        </>
                    )
                }}
            />
        </div>
    )
}

export default GearDatabaseList
